<div class="backDrop" *ngIf="showDialog$ | async">
	<ng-container *ngIf="afOutput$ | async as afOutput">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">{{separateWords(afOutput.state)}}</h4>
				</div>

				<div class="modal-body">
					<div class="message-container">
						{{afOutput.message}}
					</div>

					<div class="output-option" *ngFor="let option of afOutput.options">
						<button type="button" class="btn {{option.buttonClass}}" (click)="selectOption(option)">
							{{option.name}}
						</button>
						<div class="description-container">
							{{option.description}}
						</div>
						<div class="output-option-arguments-container">
							<div class="output-option-argument" *ngFor="let argument of option.arguments">
								<div class="argument-label">{{argument.label}}</div>
								<dx-text-box *ngIf="argument.dataType === 'string'" [(ngModel)]="argument.value"></dx-text-box>
								<dx-number-box *ngIf="argument.dataType === 'number'" [(ngModel)]="argument.value"></dx-number-box>
							</div>
						</div>
					</div>
				</div>

				<div class="modal-footer">
					<button type="button" class="btn btn-primary" (click)="exit()">
						Exit
					</button>
				</div>
			</div>
		</div>
	</ng-container>
</div>
